<template>
  <div class="central_content">
    <div class="search_list">
      <div class="text">查询：</div>
      <Input
        style="width: 200px"
        v-model="parameter.phone"
        @input="
          parameter.pageNow = 0;
          total = 0;
          getData();
        "
        search
        placeholder="请输入手机号"
      />
      <Button
        @click="
          upData = {};
          title = '添加';
          Show = true;
        "
        style="margin-left: 15px"
        type="primary"
      >添加</Button>
    </div>

    <Table
      border
      class="table_style"
      :columns="columns"
      :data="userList.list"
      :highlight-row="true"
    >
      <template slot-scope="{ row, index }" slot="config">
        <Button
          @click="
            upData = row;
            title = '删除';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
        >删除</Button>
      </template>
    </Table>
    <Modal width="500" v-model="Show" :title="title" @on-ok="UaorderShip">
      <div v-if="title == '删除'">删除</div>
      <div v-else>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>手机号:</div>
          <div>
            <Input v-model="upData.phone" placeholder="手机号" style="width: 300px" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>身份证号:</div>
          <div>
            <Input v-model="upData.idNo" placeholder="身份证号码" style="width: 300px" />
          </div>
        </div>
      </div>
    </Modal>
    <Page :total="userList.total" @on-change="switchover" />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      userList: { list: [] },
      title: "",
      upData: {},
      Show: false,
      parameter: {
        pageNow: 1
      },
      columns: [
        {
          title: "id",
          className: "fontcolor",
          align: "center",
          key: "id"
        },
        {
          title: "手机号",
          className: "fontcolor",
          align: "center",
          key: "phone"
        },
        {
          title: "身份证号",
          className: "fontcolor",
          align: "center",
          key: "idNo"
        },
        {
          title: "创建时间",
          align: "center",
          className: "fontcolor",
          key: "createTime"
        },

        {
          title: "操作",
          className: "fontcolor",
          align: "center",
          slot: "config",
          fixed: "right"
        }
      ]
    };
  },
  mounted: function() {
    this.getData();
  },
  methods: {
    UaorderShip() {
      if (this.title == "添加") {
        api
          .BlacklistAdd({
            phone: this.upData.phone,
            idNo: this.upData.idNo
          })
          .then(res => {
            if (res.body.status) {
              this.$Message.info(res.body.message);
            }
            this.getData();
          });
      }

      if (this.title == "删除") {
        api.BlacklistDel(this.upData.id).then(res => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
    },

    switchover(pageNow) {
      this.parameter.pageNow = pageNow;
      this.getData();
    },

    getData() {
      api.BlacklistQueryList(this.parameter).then(res => {
        this.userList = res.body.data;
      });
    }
  }
};
</script>

<style scoped>
</style>